import { Component, Input, Output, EventEmitter, OnChanges, SimpleChanges, Renderer2 } from '@angular/core';

@Component({
  selector: 'app-drawer',
  templateUrl: './drawer.component.html',
  styleUrls: ['./drawer.component.scss']
})
export class DrawerComponent implements OnChanges {
  @Input() visible = false;
  @Output() visibleChange = new EventEmitter<boolean>();

  @Input() customClass: string = '';

  @Input() showCloseButton = true;
  constructor(private renderer: Renderer2) { }

  close() {
    this.visible = false;
    this.visibleChange.emit(this.visible);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.visible) {
      this.renderer.addClass(document.body, 'drawer-open');
    } else {
      this.renderer.removeClass(document.body, 'drawer-open');
    }
  }

}
